class BenefitPopupList {
  constructor(root) {
    this.root = root;
    this.rootId = root.id;
    this.dialogs = root.querySelectorAll('[data-bpcl-dialog]');
    this.init();
  }

  init() {
    // Open dialog buttons
    this.root.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-bpcl-open]');
      if (openBtn) {
        this.openDialog(openBtn);
        return;
      }

      // Close buttons
      const closeBtn = e.target.closest('[data-bpcl-close]');
      if (closeBtn) {
        this.closeDialog(closeBtn.closest('dialog'));
      }
    });

    // Click outside to close
    this.dialogs.forEach(dialog => {
      dialog.addEventListener('click', (e) => {
        const card = dialog.querySelector('.bpcl-card');
        if (!card) return;
        
        const rect = card.getBoundingClientRect();
        if (
          e.clientX < rect.left ||
          e.clientX > rect.right ||
          e.clientY < rect.top ||
          e.clientY > rect.bottom
        ) {
          this.closeDialog(dialog);
        }
      });
    });
  }

  openDialog(button) {
    const dialogId = button.getAttribute('data-bpcl-open');
    const dialog = document.getElementById(`${this.rootId}-${dialogId}`);
    
    if (!dialog) {
      console.error('Dialog not found:', `${this.rootId}-${dialogId}`);
      return;
    }

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
      dialog.addEventListener('close', () => {
        try {
          button.focus({ preventScroll: true });
        } catch (_) {
          button.focus();
        }
      }, { once: true });
    } else {
      dialog.setAttribute('open', '');
    }
  }

  closeDialog(dialog) {
    if (!dialog) return;
    
    if (dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }
}

// Initialize all benefit popup lists
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBenefitPopups);
} else {
  initBenefitPopups();
}

function initBenefitPopups() {
  document.querySelectorAll('[id^="bpcl-"]').forEach(root => {
    new BenefitPopupList(root);
  });
}

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[id^="bpcl-"]');
    if (root) new BenefitPopupList(root);
  });
}